export default "__VITE_ASSET__JBj8mVO5__"